import type { FC, RefObject } from "react";
import { useCallback } from "react";

import { Button, Popover, PopoverClose, PopoverTrigger } from "@similarweb/ui-components";

import {
    SettingPopoverContentStyled,
    SettingPopoverDescriptionStyled,
    SettingPopoverHeadingStyled,
    SettingPopoverImageStyled,
    SettingPopoverTitleWrapper,
} from "app/components/AddonsSettingsPopover/StyledSettingsPopover";
import { translate } from "app/filters/i18nFilter";
import { AssetsService } from "app/services/AssetsService";
import { allTrackers } from "app/services/track/track";
import { goToAddonsPage } from "app/UtilitiesAndConstants/UtilityFunctions/goToAddonsPage";

interface ISettingsPopoverProp {
    containerRef: RefObject<HTMLElement>;
    isOpen: boolean;
    onClosePopover: () => void;
}

export const SettingsPopover: FC<ISettingsPopoverProp> = ({ containerRef, isOpen, onClosePopover }) => {
    const onGoToAddonHubClick = useCallback(() => {
        allTrackers.dispatchTrackEvent("internal link", "click", "toaster/settings");

        goToAddonsPage({});
    }, []);

    const onCloseClick = useCallback(() => {
        allTrackers.dispatchTrackEvent("internal link", "click", "toaster/settings/close");

        onClosePopover();
    }, [onClosePopover]);

    return (
        <Popover
            open={isOpen}
            isClickOutsideEnabled={false}
            placement="right-end"
        >
            <PopoverTrigger elementRef={containerRef} />
            <SettingPopoverContentStyled>
                <SettingPopoverHeadingStyled>
                    <PopoverClose onClick={onCloseClick} />
                </SettingPopoverHeadingStyled>
                <SettingPopoverDescriptionStyled>
                    <SettingPopoverImageStyled
                        src={AssetsService.assetUrl("/images/lego.gif")}
                        alt="lego"
                    />

                    <SettingPopoverTitleWrapper>{translate("addon.toaster.description")}</SettingPopoverTitleWrapper>

                    <Button
                        width="88%"
                        label={translate("addon.toaster.cta")}
                        onClick={onGoToAddonHubClick}
                        type="outlined"
                    />
                </SettingPopoverDescriptionStyled>
            </SettingPopoverContentStyled>
        </Popover>
    );
};
